import { VStack } from '@chakra-ui/react'
import Sticky from 'react-stickynode'

import {
  TitleWidget,
  CheckListWidget,
  BundlePromoImage,
} from '@/features/Courses/components/StickyWidget'
import { useCourseContext } from '@/features/Courses/contexts/CourseContext'

function CourseSticky(): React.ReactElement {
  const course = useCourseContext()

  return (
    <Sticky bottomBoundary="#course-container" top={72}>
      <VStack spacing="4" sx={{ alignItems: 'stretch', mt: 8 }}>
        <TitleWidget course={course} />
        <BundlePromoImage course={course} />
        <CheckListWidget title="หลักสูตรนี้ :" items={course.checklist || []} />
      </VStack>
    </Sticky>
  )
}

export default CourseSticky
